<section id="section-remission" *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" [formGroup]="formRemission">
        <div class="ps-2 pe-2">
          <div class="row pt-1">
            <div class="col">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                [width]="'6rem'" (onClick)="goToBack($event)" [severity]="null"></app-custom-button>
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>

            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
              <!-- Adjuntar archivos -->
              <app-custom-button [title]="'Adjuntar archivos'" [icon]="'pi pi-paperclip'" [severity]="'contrast'"
                (onClick)="openAttachFile()"></app-custom-button>
              <app-custom-modal #attachFileRemission [header]="'Adjuntar archivos'" [children]="componentAttachFiles"
                [closable]="true" [width]="'40vw'" [inputs$]="inputsForAttachFiles$" [output$]="outputForAttachFiles$"
                hidden></app-custom-modal>

              <app-custom-button [title]="'Eliminar'" [severity]="'contrast'" [icon]="'pi pi-trash'"
                (onClick)="deleteRemission()"></app-custom-button>

              <app-custom-button [title]="'Imprimir'" [severity]="'contrast'" [icon]="'pi pi-print'"
                (onClick)="printPage()"></app-custom-button>


              <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
                [width]="'5.5rem'" [severity]="'success'" [variant]="undefined"
                (onClick)="createNewRemission()"></app-custom-button>
            </div>
            <hr class="my-1">
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-audit-info [userNameCreate]="remissionContract.userNameCreate"
                [createDate]="remissionContract.createDate" [userNameUpdate]="remissionContract.userNameUpdate"
                [updateDate]="remissionContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
          <!-- Formulario Captura -->
          <div class="row mb-1 d-flex justify-content-between">
            <div class="col-lg-7">
              <div class="row">
                <div class="col-lg-3 col-md-2 col-sm-4 col-6">
                  <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                    [required]="true" [recovery]="true" (onChangeSelect)="getBranch($event, true)"></app-custom-select>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-6">
                  <app-custom-input-number formControlName="consecutive" [labelText]="'Número'" [required]="true"
                    [recovery]="true" (onChangeNumber)="changeConsecutive()"></app-custom-input-number>
                </div>
                <div class="col-lg-1 col-md-2 col-sm-3 col-6">
                  <app-custom-input-text [disabled]="true" [labelText]="'Tipo'"
                    [value]="remissionContract.isTransfer ? 'Traslado' : 'Remisión'">
                  </app-custom-input-text>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-3 col-6">
                  <app-custom-input-number formControlName="alterNumber" [labelText]="'Nro.Alterno'"
                    (onChangeNumber)="changeValues()"></app-custom-input-number>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-3 col-6">
                  <app-custom-datepicker formControlName="dateRemission" [labelText]="'Fecha Remisión'"
                    [required]="true" (onChangeDate)="changeDateRemission()"></app-custom-datepicker>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-3 col-6">
                  <app-custom-datepicker formControlName="dateInvoice" [labelText]="'Fecha Factura'" [required]="true"
                    (onChangeDate)="changeDateInvoice()"></app-custom-datepicker>
                </div>
                <div class="col-lg-6 col-md-4 col-sm-6 col-12">
                  <app-custom-autocomplete formControlName="clientId" [labelText]="'Cliente'" [list]="listClients"
                    [required]="true" [class]="getClass('client')" (onChangeSelect)="getClient($event, true)">
                  </app-custom-autocomplete>
                </div>
                <div class="col-lg-6 col-md-4 col-sm-4 col-12">
                  <app-custom-autocomplete formControlName="costCenterId" [labelText]="'C.Costos'"
                    [list]="filteredCostCenters" [required]="true" [class]="getClass('costCenter')"
                    (onChangeSelect)="getCostCenter($event, true)">
                  </app-custom-autocomplete>
                </div>
                <div class="col-lg-9 col-md-4 col-sm-4 col-12">
                  <app-custom-input-text formControlName="observationCostCenter" [labelText]="'Observación C.Costos'">
                  </app-custom-input-text>
                </div>
                <div class="col-lg-1 col-md-2 col-sm-2 col-6">
                  <app-custom-input-text formControlName="swInvoiceM2" [labelText]="'Factura m2'">
                  </app-custom-input-text>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-6">
                  <app-custom-input-text formControlName="unitValueM2" [labelText]="'Vr.Unitario m2'">
                  </app-custom-input-text>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-6">
                  <app-custom-autocomplete formControlName="transporterId" [labelText]="'Transportador'"
                    [list]="listTransporters" (onChangeSelect)="getTransporter($event)" [required]="true">
                  </app-custom-autocomplete>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-6">
                  <app-custom-autocomplete formControlName="vehicleId" [labelText]="'Vehículo'" [list]="listVehicles"
                    (onChangeSelect)="getVehicle($event)" [required]="true">
                  </app-custom-autocomplete>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-6">
                  <app-custom-input-decimal formControlName="transportValue" [labelText]="'Vr.Tansp. Cobrar'"
                    [disabled]="true"></app-custom-input-decimal>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-6">
                  <app-custom-input-decimal formControlName="transportValuePay" [labelText]="'Vr.Tansp. Pagar'"
                    [disabled]="true" (onChangeNumber)="changeValues()"></app-custom-input-decimal>
                </div>
                @if(swIndicators) {
                <div class="col-lg-6 col-md-4 col-sm-6 col-12">
                  <app-custom-textarea formControlName="printObservation" [labelText]="'Observación Impresión'"
                    [autoResize]="false" [rows]="1" (onChangeText)="changeValues()"
                    [maxLength]="250"></app-custom-textarea>
                </div>
                <div class="col-lg-6 col-md-4 col-sm-6 col-12">
                  <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [autoResize]="false"
                    [rows]="1" (onChangeText)="changeValues()" [maxLength]="250"></app-custom-textarea>
                </div>
                }
              </div>
            </div>
            <div class="col-lg-5 ps-lg-5">
              <div class="row">
                <div class="col-lg-3 col-md-2 col-sm-3 col-6">
                  <app-custom-tag [label]="'Estado'" [severity]="severityState" [value]="stateText"></app-custom-tag>
                </div>
                <div class="col-lg-9 col-md-8 col-sm-9 col-12 d-flex align-items-end mt-2 gap-1">
                  <app-custom-button [icon]="iconState" [title]="titleState" [severity]="'primary'"
                    (onClick)="changeState()"></app-custom-button>
                  <app-custom-button [title]="'Anular remisión'" [icon]="'pi pi-ban'" [severity]="'warn'"
                    (onClick)="annulRemission()"></app-custom-button>
                  <app-custom-checkbox formControlName="swBlock" class="mt-1" [labelText]="'Bloq.'"
                    (onChangeCheckBox)="blockRemission($event)" [disabled]="true"></app-custom-checkbox>
                  <app-custom-chip class="ms-2 me-1" [label]="'Corte: ' + invoicingCutoffCode" />
                  <app-custom-chip class="me-1" [ngClass]="stateRentalPeriod ? '' : 'text-danger'"
                    [label]="'Periodo: ' + rentalPeriod" />
                </div>
                <div class="col-md-3 col-sm-3 col-6" [ngClass]="swAppMovil ? 'col-lg-3' : 'col-lg-6'">
                  <app-custom-input-text formControlName="wildcard" [labelText]="'Comodín 1'"
                    (onChangeText)="changeValues()" [maxLength]="20">
                  </app-custom-input-text>
                </div>
                <div class="col-md-3 col-sm-3 col-6" [ngClass]="swAppMovil ? 'col-lg-3' : 'col-lg-6'">
                  <app-custom-input-text formControlName="wildcard2" [labelText]="'Comodín 2'"
                    (onChangeText)="changeValues()" [maxLength]="20">
                  </app-custom-input-text>
                </div>
                @if(swAppMovil) {
                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                  <app-custom-autocomplete formControlName="userId" [labelText]="'Usuario Responsable'"
                    [list]="listUsersApp">
                  </app-custom-autocomplete>
                </div>
                }
                @if(!swIndicators) {
                <div class="col-lg-12 col-md-6 col-sm-6 col-12">
                  <app-custom-textarea formControlName="printObservation" [labelText]="'Observación Impresión'"
                    [autoResize]="false" [rows]="1" (onChangeText)="changeValues()"
                    [maxLength]="250"></app-custom-textarea>
                </div>
                <div class="col-lg-12 col-md-6 col-sm-6 col-12">
                  <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [autoResize]="false"
                    [rows]="1" (onChangeText)="changeValues()" [maxLength]="250"></app-custom-textarea>
                </div>
                } @else{
                <div class="col-12 fieldset-remission">
                  <p-fieldset legend="Indicadores">
                    <div class="row fieldset-content px-1 py-1">
                      <div class="col-lg-6 col-md-2 col-sm-6 col-12">
                        <app-custom-datetime-picker formControlName="compromiseDate" [labelText]="'Fecha Entrega'"
                          [required]="false"></app-custom-datetime-picker>
                      </div>
                      <div class="col-lg-6 col-md-2 col-sm-6 col-12">
                        <app-custom-select formControlName="conceptTypeRequirementId" [labelText]="'Tipo Requerimiento'"
                          [list]="listTypeRequirements" [required]="false" [showClear]="true"></app-custom-select>
                      </div>
                      <div class="col-lg-6 col-md-3 col-sm-6 col-12">
                        <app-custom-select formControlName="conceptDelayReasonId" [labelText]="'Motivo Demora'"
                          [list]="listDelayReasons" [required]="false" [showClear]="true"></app-custom-select>
                      </div>
                      <div class="col-lg-6 col-md-3 col-sm-6 col-12">
                        <app-custom-select formControlName="conceptTypeAvailabilityId"
                          [labelText]="'Tipo Disponibilidad'" [list]="listTypeAvailabilitys" [required]="false"
                          [showClear]="true"></app-custom-select>
                      </div>
                    </div>
                  </p-fieldset>
                </div>
                }
                <div class="col-12 d-flex justify-content-end mt-1">
                  <app-custom-button [label]="'Guardar'" [severity]="'primary'" [disabled]="disabledBtnSave"
                    [variant]="undefined" (onClick)="onSave()">
                  </app-custom-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <app-remission-detail [remissionModel]="remissionContract" [disabledDetail]="disabledDetail"
      [quantityDetails]="quantityDetails" [permissionUpdatable]="permissionUpdatable"
      [permissionsUser]="permissionsUser" [userAuthenticated]="userAuthenticated"
      (emitQuantityDetails)="quantityDetails = $event" (reloadRemissionContract)="getRemissionById()">
    </app-remission-detail>
  </div>
</section>

<!-- Impresión -->
<app-print-remission id="print-remission" [companyId]="companyId" [formatModel]="formatModel"
  [remissionModel]="remissionPrintModel" [swIncludeStore]="swIncludeStore" [editFormat]="false" [focusText]="false"
  (finishLoadingPrint)="finishLoading($event)">
</app-print-remission>

<!-- Modal consecutivo inicial (sin registros) -->
<app-custom-modal #initialConsecutive [header]="'Número de documento inicial'"
  [children]="componentInitialConsecutiveModal" [width]="'25rem'" hidden [output$]="outputForInitialConsecutive$">
</app-custom-modal>

<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>